export default "__VITE_ASSET__737d430f__"